export default "__VITE_ASSET__CMn2NheL__"